export const WIDGET_ELEMENTS = ['mf-chart', 'mf-filter', 'mf-action'];
export const ALLOWED_TAGS = [
    ...WIDGET_ELEMENTS,
    'div',
    'span',
    'section',
    'header',
    'footer',
    'article',
    'aside',
    'nav',
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'strong',
    'em',
    'b',
    'i',
    'u',
    's',
    'small',
    'mark',
    'code',
    'pre',
    'blockquote',
    'br',
    'hr',
    'sup',
    'sub',
    'abbr',
    'time',
    'ul',
    'ol',
    'li',
    'dl',
    'dt',
    'dd',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td',
    'caption',
    'colgroup',
    'col',
    'details',
    'summary',
    'figure',
    'figcaption',
    'img',
    'button',
    'progress',
    'a',
    'svg',
    'g',
    'path',
    'circle',
    'rect',
    'line',
    'polyline',
    'polygon',
    'text',
];
export const ALLOWED_ATTRIBUTES = [
    'class',
    'alt',
    'src',
    'href',
    'title',
    'colspan',
    'rowspan',
    'scope',
    'datetime',
    'open',
    'dataset',
    'field',
    'height',
    'name',
    'type',
    'viewBox',
    'd',
    'cx',
    'cy',
    'r',
    'x',
    'y',
    'x1',
    'y1',
    'x2',
    'y2',
    'width',
    'points',
    'fill',
    'stroke',
    'stroke-width',
    'role',
    'tabindex',
    'value',
    'max',
];
let assetOrigins = [];
/** Origins images may come from besides `data:` images; each host sets its own asset store. */
export function setAssetOrigins(origins) {
    assetOrigins = origins.map((origin) => new URL(origin).origin);
}
/** A link a widget may open: a web page, never a script, a file or another app's scheme. */
export function webPageUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
    }
    catch {
        return undefined;
    }
}
export function isAllowedAssetUrl(url) {
    if (/^data:image\/(png|jpe?g|gif|webp|svg\+xml);/i.test(url))
        return true;
    try {
        return assetOrigins.includes(new URL(url).origin);
    }
    catch {
        return false;
    }
}
